import { SupplierAccountWebService } from '@linktivity/gds-neo';
import config from '../config';

const supplierAccountApi = new SupplierAccountWebService.AccountWebServiceApi(
  config
);

export default supplierAccountApi;
